import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const editClassAttributeOperations = async (
  listId: number | undefined,
  attributeId: number | undefined,
  attributeName: string,
  setIsLoading: (loading: boolean) => any,
) => {
  try {
    if (!listId || !attributeId) {
      toast.warn('לא ניךן לאתר את מזהה הרשימה ו/או התכונה');
      return;
    }

    if (!attributeName || attributeName.length < 3) {
      toast.warn('עם שם המאפיין להיות לפחות בעל שלושה תווים');
      throw new Error(`Can not find editAttribute: ${attributeName}`);
    }

    setIsLoading(true);
    await appApi.editClassAttributes(listId, attributeId, attributeName);
    globalSettingsStores.fetchSetting();
    toast.success('המאפיין עודכן בהצלחה');
    setIsLoading(false);
  } catch (e) {
    setIsLoading(false);
    console.error(
      `editClassAttributeOperations is failed with the listId: ${listId}, attributeId: ${attributeId} and the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
